<script lang="ts" setup>

</script>

<template>
  <UIcon name="i-svg-spinners-ring-resize" class="size-5 text-neutral-500" :class="$attrs.class" />
</template>
